// extracted by mini-css-extract-plugin
export default {"navWrapper":"SideNav_navWrapper__4VZrF","isOpen":"SideNav_isOpen__z71uq"};